var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLearningPortal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 26,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 21.896V4.104a2.54 2.54 0 0 1 2.542-2.541H20.57c.421 0 .762.34.762.762v16.666"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.084 1.563v10.166l3.177-2.033 3.177 2.033V1.563M3.541 19.355h17.792M3.541 24.438h17.792M3.542 24.438a2.542 2.542 0 1 1 0-5.083"
})));
export default SvgLearningPortal;